import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "modal-wrapper z-[9999]",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "flex w-full md:justify-between justify-center" };
const _hoisted_4 = { class: "icon-section md:flex hidden w-1/3 items-center justify-center" };
const _hoisted_5 = { class: "flex w-full max-w-xl flex-col items-center justify-center text-center" };
const _hoisted_6 = { class: "sm:text-lg text-sm font-semibold text-gray-700 dark:text-gray-50" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "info-note" };
const _hoisted_10 = { class: "support-box" };
const _hoisted_11 = { class: "text-start" };
const _hoisted_12 = {
    href: "mailto:suporte@plantareducacao.com.br",
    class: "font-medium text-blue-800 underline"
};
const _hoisted_13 = { class: "modal-footer" };
const _hoisted_14 = {
    for: "showAgain",
    class: "ml-2 cursor-pointer truncate"
};
import { ref, computed } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { assasService } from '@/services/asaas';
import { useAuthStore } from '@/stores';
import webStorage from '@/common/webStorage';
import UiButton from '@/components/ui/button.vue';
import UiCustomSvg from '@/components/ui/customSvg.vue';
import UiIcon from '@/components/ui/icon.vue';
import ImgAsaas from '@/assets/art/asaasActive.vue';
import ImgAsaasCancel from '@/assets/art/asaasDisabled.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'modalViewPlan',
    setup(__props, { expose: __expose }) {
        const authStore = useAuthStore();
        const isOpen = ref(false);
        const dontDisplay = ref(false);
        const status = ref('initial');
        const planInfo = ref({
            subscriptionId: '',
            name: '',
            value: 0,
            parcelValue: 0,
            installments: 0,
            mode: 'monthly',
            active: false,
            evaluation: false,
            status: '',
            createdAt: '',
            expiresAt: '',
            canceledAt: '',
            paymentAt: '',
            billingDate: '',
            renewalDate: '',
            receipt: '',
            creditCard: '',
            trialExpiresAt: ''
        });
        const open = async () => {
            try {
                const res = await assasService.info();
                if (res.subscriptionId === '') {
                    status.value = 'empty';
                    return isOpen.value = false;
                }
                planInfo.value = {
                    subscriptionId: res.subscriptionId,
                    name: res.name,
                    value: res.value,
                    parcelValue: res.value,
                    installments: 1,
                    mode: 'monthly',
                    active: res.status === 'Ativa',
                    status: res.status,
                    createdAt: res.createdAt,
                    expiresAt: res.expiresAt,
                    canceledAt: res.canceledAt,
                    paymentAt: res.paymentAt,
                    billingDate: res.billingDate,
                    renewalDate: res.renewalDate,
                    evaluation: res.evaluation,
                    receipt: res.receipt,
                    creditCard: res.creditCard,
                    trialExpiresAt: res.trialExpiresAt
                };
                status.value = 'success';
            }
            catch (e) {
                console.error('Erro ao buscar informações do plano:', e);
                status.value = 'error';
                return isOpen.value = false;
            }
            isOpen.value = true;
        };
        const isPlanActive = computed(() => planInfo.value?.active);
        const isPlanCanceled = computed(() => planInfo.value?.status === 'Cancelada');
        const modalTitle = computed(() => isPlanActive.value ? 'modalPlan.title' : 'modalPlan.expiredTitle');
        const modalMessage = computed(() => {
            if (isPlanActive.value)
                return 'modalPlan.activated';
            return isPlanCanceled.value ? 'modalPlan.canceledMessage' : 'modalPlan.expiredMessage';
        });
        const modalDescription = computed(() => {
            if (isPlanActive.value) {
                return planInfo.value.mode === 'yearly'
                    ? 'modalPlan.descriptionYearly'
                    : 'modalPlan.descriptionMonthly';
            }
            return 'modalPlan.renewalInfo';
        });
        const reminderMessage = computed(() => isPlanActive.value ? 'modalPlan.reminder' : 'modalPlan.accessNote');
        const statusColorClass = computed(() => isPlanActive.value ? 'text-green-600' : 'text-red-600');
        const formatterDay = (date) => {
            return date ? new Intl.DateTimeFormat('pt-BR', { day: 'numeric', timeZone: 'UTC' }).format(new Date(date)) : '';
        };
        const close = () => {
            if (dontDisplay.value) {
                const storageKey = `${authStore.persistentInfo.id}_showPlan`;
                webStorage.setItem(storageKey, false, true);
            }
            isOpen.value = false;
        };
        __expose({
            open,
            close
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VueFinalModal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                classes: "overflow-y-auto z-[9999]",
                "content-class": "flex justify-center items-center w-full h-full box-border overflow-hidden z-[9999]"
            }, {
                default: _withCtx(() => [
                    _createVNode(_Transition, {
                        mode: "out-in",
                        "enter-active-class": "transition duration-300 transform",
                        "enter-from-class": "opacity-0 -translate-y-8",
                        "leave-active-class": "duration-300 transform",
                        "leave-to-class": "opacity-0 -translate-y-8",
                        appear: ""
                    }, {
                        default: _withCtx(() => [
                            (isOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createVNode(UiCustomSvg, { class: "relative" }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(isPlanActive.value ? ImgAsaas : ImgAsaasCancel), { class: "h-80" }))
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t(modalTitle.value, { user: _unref(authStore).persistentInfo.name })), 1),
                                                _createElementVNode("h1", {
                                                    class: _normalizeClass(["mt-1 sm:text-3xl text-xl font-extrabold", statusColorClass.value])
                                                }, _toDisplayString(_ctx.$t(modalMessage.value)), 3),
                                                _createElementVNode("div", {
                                                    class: "my-3 sm:px-16 px-2 sm:text-base text-sm text-gray-800 dark:text-gray-50",
                                                    innerHTML: _ctx.$t(modalDescription.value, { day: formatterDay(planInfo.value.billingDate || planInfo.value.renewalDate) })
                                                }, null, 8, _hoisted_7),
                                                (isPlanActive.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                        _createVNode(UiButton, {
                                                            class: "mt-4 px-3 py-2",
                                                            type: "primary",
                                                            onClick: close
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('modalPlan.button')), 1)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createVNode(UiIcon, {
                                                        icon: "info-circle",
                                                        size: "24",
                                                        class: "mr-2 text-[--c-primary-600] sm:text-base text-sm"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(reminderMessage.value)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createVNode(UiIcon, {
                                                        icon: "message",
                                                        size: "60",
                                                        class: "mr-2 text-[--c-primary-600]"
                                                    }),
                                                    _createElementVNode("p", _hoisted_11, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('modalPlan.support.text')) + " ", 1),
                                                        _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('modalPlan.support.link')), 1),
                                                        _cache[2] || (_cache[2] = _createTextVNode(". "))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("label", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dontDisplay).value = $event)),
                                                    type: "checkbox",
                                                    name: "showAgain",
                                                    id: "showAgain"
                                                }, null, 512), [
                                                    [_vModelCheckbox, dontDisplay.value]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('input.notShowAgain')), 1)
                                            ]),
                                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "grow-0 md:grow" }, null, -1)),
                                            _createVNode(UiButton, {
                                                type: "primary",
                                                class: "px-4 py-2 text-sm uppercase outline-[0px]",
                                                onClick: close
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('button.close')), 1)
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
